import { createSelector } from 'reselect'
import { getNeededDateFormat } from '../../../helper'
import { getInvoiceViewStatus, INVOICE_STATUS, isPostPaymentInvoice } from '../../../component/Elements/table/InvoicesTable/constants'

export const selectSelectedInvoice = store => store.invoice.selectedInvoice

const EMPTY_STATUS_FILTER = []

export const selectInvoicesStatusFilter = store => store.invoice?.statusFilter ?? EMPTY_STATUS_FILTER

export const selectIsInvoiceCorrection = store => store.invoice.isInvoiceCorrection

export const selectSelectedInvoiceOrder = store => store.invoice.selectedInvoiceOrder

export const selectIsSelectedInvoicePaid = createSelector(
	selectSelectedInvoice,
	invoice => !!invoice && getInvoiceViewStatus(invoice) === INVOICE_STATUS.PAID
)

export const selectIsSelectedInvoiceCanceled = createSelector(
	selectSelectedInvoice,
	invoice => !!invoice && getInvoiceViewStatus(invoice) === INVOICE_STATUS.CANCELED
)

const getInvoiceStatusDate = invoice => isPostPaymentInvoice(invoice) && getInvoiceViewStatus(invoice) === INVOICE_STATUS.PAID
	? invoice.order?.paidDate ?? invoice.order?.orderDate
	: invoice?.statusChangedDate

export const selectSelectedInvoiceStatusDate = createSelector(
	selectSelectedInvoice,
	invoice => getNeededDateFormat(getInvoiceStatusDate(invoice), 'dd.MM.yyyy HH:mm')
)
